import { render, staticRenderFns } from "./attr_vertical.vue?vue&type=template&id=51c09942&scoped=true&"
import script from "./attr_vertical.vue?vue&type=script&lang=js&"
export * from "./attr_vertical.vue?vue&type=script&lang=js&"
import style0 from "./attr_vertical.vue?vue&type=style&index=0&id=51c09942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c09942",
  null
  
)

export default component.exports